import { t } from "i18next";
import React from "react";

const FailToast = ({ message }) => {
    return (
        <>
            <div className="alert-items-message flex">
                <div className="mt-1">
                    <i className="fas fa-times-circle icon-message"></i>
                </div>
                <div className="alert-items-title ml-3">
                    <h3>{t("error")}</h3>
                    <p>{message}</p>
                </div>
            </div>
        </>
    );
};

export default FailToast;
